import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png';
import baseURL from '../url';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile';
import './Navbar.css';
import Favoritos from '../Favoritos/Favoritos';
import InputSerach from '../InputSerach/InputSearchs';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tienda, setTienda] = useState([]);

    useEffect(() => { try { Modal.setAppElement('#root'); } catch(_){} }, []);

    useEffect(() => {
        cargarBanners();
        cargarTienda();
    }, []);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannersSeleccionados = Array.isArray(data.banner) ?
                    data.banner.filter(banner => banner.seleccion === 'Si') : [];
                const bannerImages = bannersSeleccionados.map(banner => {
                    const v = banner.imagen;
                    return (v && /^https?:/i.test(v)) ? v : `${baseURL}/${String(v||'').replace(/^\//,'')}`;
                });
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false); // Asegúrate de que loading se actualice en caso de error
            });
    };


    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data?.tienda?.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo'>
                    {(() => {
                        const useFallback = !tienda?.imagen1;
                        const isTransparent = !useFallback && /\.(png|svg)$/i.test(String(tienda?.imagen1||''));
                        const src = useFallback ? logo : ((tienda?.imagen1 && /^https?:/i.test(tienda.imagen1)) ? tienda.imagen1 : `${baseURL}/${String(tienda?.imagen1||'').replace(/^\//,'')}`);
                        const cls = isTransparent ? 'logo-img transparent' : 'logo-img circle';
                        return (
                          <img
                            src={src}
                            alt="logo"
                            className={cls}
                            width={40}
                            height={40}
                            loading='lazy'
                            decoding='async'
                            onLoad={(e)=>{ try{ const iw=e.currentTarget.naturalWidth||0; const ih=e.currentTarget.naturalHeight||0; const ratio = iw && ih ? (iw/ih) : 1; if (process.env.NODE_ENV==='development') { if (iw>4096 || ih>4096 || ratio>5 || ratio<0.2) { console.warn('Logo dimensions are not recommended', { iw, ih, ratio }); } } }catch(_){ } }}
                          />
                        );
                    })()}


                    <div className='deColumnNav'>
                        {tienda?.nombre ? (
                            <h2>{tienda?.nombre}</h2>
                        ) : (
                            <h2>Mi Tienda</h2>
                        )}
                        {tienda?.eslogan ? (
                            <strong>{tienda?.eslogan}</strong>
                        ) : (
                            <strong>Mi Eslogan</strong>
                        )}


                    </div>
                </Anchor>

                <div className='deFLexNavs'>
                    <InputSerach />
                    <Favoritos />
                    <div className={`nav_toggle ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay"
                    ariaHideApp={false}
                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'></div>
                        ) : (
                            <>


                                {images.length > 0 ? (
                                    <div className='fondo'>
                                        <img
                                          src={images[0]}
                                          alt="Banner"
                                          loading='eager'
                                          decoding='sync'
                                          sizes='(max-width: 1024px) 100vw, 600px'
                                          width={600}
                                          height={338}
                                        />
                                    </div>
                                ) : (
                                    <div className='space'></div>
                                )}
                                <Profile />
                            </>
                        )}
                    </div>
                </Modal>
            </nav>
        </header>
    );
}
